import jwtDecode from 'jwt-decode';
import { REMOVE_TOKENS, STORE_TOKENS, REFRESH_TOKEN, REFRESH_TOKEN_START, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_ERROR, REQUEST, REQUEST_START, REQUEST_SUCCESS, REQUEST_ERROR, GET_TOKEN, GET_TOKEN_START, GET_TOKEN_SUCCESS, GET_TOKEN_ERROR } from './actionTypes.js';
export { GET_TOKEN, GET_TOKEN_ERROR, GET_TOKEN_START, GET_TOKEN_SUCCESS, REFRESH_TOKEN, REFRESH_TOKEN_ERROR, REFRESH_TOKEN_START, REFRESH_TOKEN_SUCCESS, REMOVE_TOKENS, REMOVE_TOKENS_ERROR, REMOVE_TOKENS_START, REMOVE_TOKENS_SUCCESS, REQUEST, REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS, SET_SCOPE, STORE_TOKENS, STORE_TOKENS_ERROR, STORE_TOKENS_START, STORE_TOKENS_SUCCESS } from './actionTypes.js';
export { default as _network } from './reducer.js';
import Request from './request.js';
import isExpired from './isExpired.js';
import storeTokens from './storeTokens.js';
import removeTokens from './removeTokens.js';
import refreshToken from './refreshToken.js';
export { default as picoAPIHelper } from './picoApiHelper.js';
import * as broadcastChannel from './transports/broadcastChannel.js';
export { broadcastChannel as broadcastChannelTransport };

var request = null;
var networkMiddleware = function networkMiddleware(_ref) {
  var accessTokenAdapters = _ref.accessTokenAdapters,
    refreshTokenAdapters = _ref.refreshTokenAdapters,
    _ref$tokenKey = _ref.tokenKey,
    tokenKey = _ref$tokenKey === void 0 ? 'default' : _ref$tokenKey,
    concurrentRequests = _ref.concurrentRequests,
    transport = _ref.transport,
    _ref$preRequestHook = _ref.preRequestHook,
    preRequestHook = _ref$preRequestHook === void 0 ? async function (config) {
      return config;
    } : _ref$preRequestHook,
    _ref$postRequestHook = _ref.postRequestHook,
    postRequestHook = _ref$postRequestHook === void 0 ? async function (_ref2) {
      var response = _ref2.response;
      return response;
    } : _ref$postRequestHook;
  return function (_ref3) {
    var dispatch = _ref3.dispatch,
      getState = _ref3.getState;
    return function (next) {
      return async function (action) {
        var state = getState();
        if (action && action.type) {
          await next(action);
        } else {
          return;
        }
        if (request === null) {
          request = new Request({
            transport: transport,
            concurrentRequests: concurrentRequests,
            preRequestHook: preRequestHook,
            postRequestHook: postRequestHook
          });
        }
        if (action.type === REMOVE_TOKENS) {
          removeTokens({
            dispatch: dispatch,
            tokenKey: tokenKey
          });
        }
        if (action.type === STORE_TOKENS) {
          var parsedTokens;
          if (action.data) {
            parsedTokens = await accessTokenAdapters.response({
              data: action.data,
              state: state
            });
          } else {
            parsedTokens = {
              access_token: action.access_token,
              refresh_token: action.refresh_token,
              scope: state._network.scope
            };
          }
          storeTokens({
            dispatch: dispatch,
            tokens: parsedTokens,
            tokenKey: tokenKey
          });
        }
        if (action.type === REFRESH_TOKEN) {
          var refreshConfig = refreshTokenAdapters.request({
            access_token: state._network.access_token[tokenKey],
            refresh_token: state._network.refresh_token[tokenKey],
            scope: state._network.scope,
            decode: function decode(encodedToken) {
              return jwtDecode(encodedToken);
            }
          });
          var refreshResponse = await request.send({
            config: refreshConfig,
            onStart: function onStart(payload) {
              dispatch(Object.assign({
                type: REFRESH_TOKEN_START
              }, payload));
            },
            onSuccess: function onSuccess(payload) {
              dispatch(Object.assign({
                type: REFRESH_TOKEN_SUCCESS
              }, payload));
            },
            onError: function onError(payload) {
              dispatch(Object.assign({
                type: REFRESH_TOKEN_ERROR
              }, payload));
            }
          });
          var parsedRefreshTokens = refreshTokenAdapters.response({
            data: refreshResponse.data
          });
          storeTokens({
            dispatch: dispatch,
            tokens: parsedRefreshTokens,
            tokenKey: tokenKey
          });
        }
        if (action.type === REQUEST) {
          var _action$config;
          var refresh_token = state._network.refresh_token[tokenKey];
          var access_token = state._network.access_token[tokenKey] || null;
          if (refresh_token && (!access_token || isExpired(access_token))) {
            var tokens = await refreshToken({
              tokenKey: tokenKey,
              refreshTokenAdapters: refreshTokenAdapters,
              state: state,
              dispatch: dispatch,
              request: request
            });
            access_token = tokens.access_token || tokens.token || null;
          }
          var headers = Object.assign({}, (action === null || action === void 0 ? void 0 : (_action$config = action.config) === null || _action$config === void 0 ? void 0 : _action$config.headers) || {});
          if (access_token) {
            headers.Authorization = "Bearer " + access_token;
          }
          var config = Object.assign({}, action.config, {
            headers: headers
          });
          return await request.send({
            config: config,
            onStart: function onStart(payload) {
              dispatch(Object.assign({
                type: REQUEST_START
              }, payload));
            },
            onSuccess: function onSuccess(payload) {
              dispatch(Object.assign({
                type: REQUEST_SUCCESS
              }, payload));
            },
            onError: function onError(payload) {
              dispatch(Object.assign({
                type: REQUEST_ERROR
              }, payload));
            }
          });
        }
        if (action.type === GET_TOKEN) {
          return await request.send({
            config: action.config,
            onStart: function onStart(payload) {
              dispatch(Object.assign({
                type: GET_TOKEN_START
              }, payload));
            },
            onSuccess: function onSuccess(payload) {
              dispatch(Object.assign({
                type: GET_TOKEN_SUCCESS
              }, payload));
            },
            onError: function onError(payload) {
              dispatch(Object.assign({
                type: GET_TOKEN_ERROR
              }, payload));
            }
          });
        }
      };
    };
  };
};
var createNetworkMiddleware = function createNetworkMiddleware(_ref4) {
  var accessTokenAdapters = _ref4.accessTokenAdapters,
    refreshTokenAdapters = _ref4.refreshTokenAdapters,
    tokenKey = _ref4.tokenKey,
    concurrentRequests = _ref4.concurrentRequests,
    transport = _ref4.transport,
    preRequestHook = _ref4.preRequestHook,
    postRequestHook = _ref4.postRequestHook;
  return networkMiddleware({
    accessTokenAdapters: accessTokenAdapters,
    refreshTokenAdapters: refreshTokenAdapters,
    tokenKey: tokenKey,
    concurrentRequests: concurrentRequests,
    transport: transport,
    preRequestHook: preRequestHook,
    postRequestHook: postRequestHook
  });
};

export { createNetworkMiddleware };
//# sourceMappingURL=index.js.map
